export const tablePaginationConfig = {
  current: 1,
  defaultPageSize: 25,
  defaultCurrent: 1,
  showSizeChanger: true,
  pageSizeOptions: ['10', '25', '50', '100'],
  showTotal: (total: number, [from, to]: [number, number]) =>
    `Displaying ${from} - ${to} of ${total} results`,
};
